/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowTurnUpRight: {
  name: 'arrow-turn-up-right';
  data: string;
} = {
  name: 'arrow-turn-up-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.293 6.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L16.586 12H7v5a1 1 0 1 1-2 0v-5a2 2 0 0 1 2-2h9.586l-2.293-2.293a1 1 0 0 1 0-1.414Z" fill="currentColor"/></svg>`,
};
